import React from 'react';
import { ContactRootSystem } from './ContactRootSystem';
export function Contact() {
  return <ContactRootSystem data-id="element-420" />;
}